import { gql } from '@apollo/client';

export const UPDATE_UNLOAD_RECORD_PHOTOS = gql`
  mutation UpdateUnloadRecordPhotos($input: UpdateUnloadRecordPhotosInput!) {
    updateUnloadRecordPhotos(input: $input)
  }
`;

export interface UpdateUnloadRecordPhotosInput {
    unloadingId: number;
    photoS3Keys: string[];
}

export interface UpdateUnloadRecordPhotosResponse {
    updateUnloadRecordPhotos: boolean;
}
